<div class="energiemonitor">
  <app-back-button [title]="'module.energieMonitor.moduleName' | translate" (backClicked)="gotoDashboard()"> </app-back-button>

  <iframe title="energiemonitor" class="demo" [src]="energieMonitorUrl" height="1100" width="1320" *ngIf="energieMonitorUrl"></iframe>
  <header class="sub-header">{{ 'module.energieMonitor.subHeader1Text' | translate }}</header>
  <p>{{ 'module.energieMonitor.subHeader2Text' | translate }}</p>
  <span [innerHTML]="'module.energieMonitor.energyMonitorContent1' | translate"> </span>
  <header class="sub-header">{{ 'module.energieMonitor.subHeader3Text' | translate }}</header>
  <span [innerHTML]="'module.energieMonitor.energyMonitorContent2' | translate"> </span>
  <div *ngIf="environment.tenant === 'lew'">
    <p>
      {{ 'module.energieMonitor.lewenergyMonitorText' | translate
      }}<a class="link" (click)="goToLink()">{{ 'module.energieMonitor.lewenergyMonitorLink' | translate }}</a>
    </p>
  </div>
</div>
